import { useTranslation } from 'react-i18next'

import SuccessModalIcon from '@/presentation/assets/svg/SuccessModalIcon.svg'

const SuccessModal: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#70707059] px-4">
      <div className="flex flex-col items-center gap-4 rounded-lg bg-white p-8 shadow-md">
        <img src={SuccessModalIcon} className="size-24" />

        <span className="text-lg font-bold text-[#4F6066]">
          {t('EVALUATION_SENT', 'Avaliação enviada!')}
        </span>
      </div>
    </div>
  )
}

export default SuccessModal
